import { Info } from 'lucide-react';
import { describeRule } from '../utils/ruleSummary';

export default function RuleSummary({
  values,
  targetName,
  metricLabel,
  channelName,
}) {
  const summary = describeRule(values, {
    targetName,
    metricLabel,
    channelName,
  });
  return (
    <section
      aria-label="خلاصه رفتار قانون"
      aria-live="polite"
      className="space-y-3 rounded-xl border border-blue-200 bg-blue-50/60 p-4 dark:border-blue-800 dark:bg-blue-950/20"
    >
      <h3 className="flex items-center gap-2 text-sm font-bold text-blue-900 dark:text-blue-200">
        <Info size={18} />
        این قانون چه می‌کند؟
      </h3>
      <p className="text-sm leading-8 text-gray-900 dark:text-gray-100">
        {summary.text}
      </p>
      {summary.notes.map((note) => (
        <p
          key={note}
          className="text-xs leading-7 text-gray-600 dark:text-gray-300"
        >
          {note}
        </p>
      ))}
    </section>
  );
}
